import { Component, OnInit, OnDestroy } from '@angular/core';
import { SocketService } from '../../services/socket.service';

@Component({
    selector   : 'my-socketsms',
    template: require('./socketSms.component.html'),
    styles: [require('./socketSms.component.scss')],
    providers  : [SocketService]
})

export class SocketsmsComponent implements OnInit, OnDestroy {

    connection;
    items         = [];
    itemOpen      = null;
    panel: string = 'sms';
    infos         = {
        noSeen: 0,
        data  : []
    };
    currentInfo: null;

    constructor(private socketService: SocketService) {

    }

    ngOnInit() {
        this.socketService.get()
            .subscribe(
                (item)=> {
                    if (item.action == 'poulpe')
                        this.poulpe(item.item);
                    if (item.action == 'smsUp')
                        this.smsUp(item.item);
                    if (item.action == 'smsNew')
                        this.smsNew(item.item);
                    // if (item.action == 'infoNew')
                    //     this.infoNew(item.item);
                    // if (item.action == 'infoPoulpe')
                    //     this.infoPoulpe(item.item);
                },
            );
    }

    open(id) {
        if (this.itemOpen == id) {
            this.itemOpen = null;
        } else {
            this.itemOpen = id;
        }
    }

    ngOnDestroy(): void {
        this.connection.unsubscribe();
    }

    poulpe(items) {
        if (items) {
            this.items = items.reverse();
        }
    }

    smsUp(item) {
        this.items.forEach((i)=> {
            if (i._id == item._id) {
                i.state = item.state;
            }
        });
    }

    smsNew(item) {
        this.items.unshift(item);
    }

    //INFO

    // infoPoulpe(items) {
    //     this.infos.data = items.reverse();
    //     this.infos.noSeen = 0;
    //     this.infos.data.forEach((e) => {
    //         if (!e.seen)
    //             this.infos.noSeen++;
    //     })
    // }

    // infoNew(item) {
    //     this.infos.data.unshift(item);
    //     this.infos.noSeen++;
    // }


    // openInfo(item) {
    //     if (!item.seen) {
    //         item.seen = true;
    //         this.infos.noSeen--;
    //         // this.socketService.infoSeen(item._id);
    //     }
    //     if (this.currentInfo == item._id){
    //         this.currentInfo = null;
    //     } else {
    //         this.currentInfo = item._id;
    //     }
    // }

    //TOOLS

    getDate(date: Date) {
        date = new Date(date);
        return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/components/socketSms/socketSms.component.ts